import * as React from "react";
const SvgFiRrHorse = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-horse_svg__a)">
      <path
        fill="#062147"
        d="m4.875 10.503-.005.006c-.035.005-.012-.002.005-.006M24 8.606a2.016 2.016 0 0 1-1.763 1.997l-2.236.28v2.016c0 1.48-.199 2.436-.616 3.896L19 18.605v2.426A2.973 2.973 0 0 1 16.03 24C14.332 24 13 22.669 13 21.03V20h-1.617l-.175 1.398A2.976 2.976 0 0 1 8.261 24a2.969 2.969 0 0 1-2.942-3.377l.213-1.543c-.112-.36-.25-.755-.396-1.172-.491-1.405-1.097-3.141-1.139-4.738C2.671 14.253 2 16.206 2 19a1 1 0 0 1-2 0c0-5.683 2.734-7.774 4.87-8.492.028-.01.018-.01.005-.006A4.03 4.03 0 0 1 8.015 9H11.5a.5.5 0 0 0 .5-.5c.027-1.917.96-5.267 4.086-6.232.229-.977.895-1.847 1.771-2.208C18.404-.166 19 .282 19 .874v2.129c.493 1.627 1.766 2.89 3.79 3.762A2 2 0 0 1 24 8.607zm-2.011.013c-2.399-1.051-3.995-2.581-4.744-4.565-3.07.479-3.236 4.032-3.245 4.463C14 9.877 12.878 11 11.5 11H8.015c-1.113 0-2.02.893-2.021 1.989-.001 1.307.547 2.875 1.03 4.259.186.53.359 1.028.488 1.47.04.136.05.278.031.418l-.243 1.76a.96.96 0 0 0 .229.77.97.97 0 0 0 1.693-.517l.284-2.274a1 1 0 0 1 .992-.876h3.5a1 1 0 0 1 1 1v2.03c0 .535.435.97.97.97.596 0 1.03-.435 1.03-.97v-2.53q0-.105.022-.21l.423-1.98c.389-1.37.555-2.162.555-3.411v-2.016c0-1.006.753-1.86 1.752-1.984l2.237-.28z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-horse_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHorse;
